export const icebergGoldData = {
  took: 5,
  timed_out: false,
  _shards: {
    total: 22,
    successful: 22,
    skipped: 20,
    failed: 0,
  },
  hits: {
    total: {
      value: 6,
      relation: 'eq',
    },
    max_score: null,
    hits: [
      {
        _index: 'table_search_index',
        _id: '989ee883-7ee4-4cbd-9396-1ea9f3a784c4',
        _score: null,
        _source: {
          databaseSchema: {
            deleted: false,
            displayName: 'g_turbo',
            name: 'g_turbo',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>가디원 터보 연구 &amp; 개발에 사용되는 데이터 마트</p></li></ul><p></p>',
            id: '504b65ec-820d-4cc1-b1c3-e5b94b2e56fe',
            type: 'databaseSchema',
            fullyQualifiedName: 'gold-iceberg.gold.g_turbo',
          },
          serviceType: 'Iceberg',
          displayName: 'gsp_ecms1_feature_preprocessed',
          schemaDefinition: null,
          description:
            '<ul class="om-list-disc"><li class="om-leading-normal"><p>GSP ECMS1 기반 feature 데이터</p></li></ul><p></p>',
          owners: [
            {
              deleted: false,
              displayName: 'DI',
              inherited: true,
              name: 'DI',
              description:
                '<ul class="om-list-disc"><li class="om-leading-normal"><p>데이터 과학자, 분석가 소속 팀</p></li></ul><p></p>',
              id: '3b28a5be-4517-48f0-84f4-01ae147493bd',
              type: 'team',
              fullyQualifiedName: 'DI',
            },
          ],
          tierSources: {},
          fqnHash:
            '2870b486fb213438a92f4180af3df4a9.e07e81c20cf5935f5225765f0af81755.5df9be687e674cc4273916ac1fa9a834.1b69903a92956ee3786479ce3d8a431e',
          customMetrics: [],
          tableType: 'Regular',
          database: {
            deleted: false,
            displayName: 'gold',
            name: 'gold',
            id: '1d7f528b-4bfd-4d35-b2ba-628d983931bf',
            type: 'database',
            fullyQualifiedName: 'gold-iceberg.gold',
          },
          descriptionStatus: 'COMPLETE',
          columnNames: [
            'amplitude_x',
            'amplitude_y',
            'frequency',
            'bandwidth',
            'bandwidth."0.07x"',
            'bandwidth."0.1x"',
            'bandwidth."0.33x"',
            'bandwidth."0.5x"',
            'bandwidth.1x',
            'bandwidth.2x',
            'bandwidth.3x',
            'bandwidth.4x',
            'bandwidth.sub',
            'max_amplitudes',
            'max_amplitudes."0.07x"',
            'max_amplitudes."0.1x"',
            'max_amplitudes."0.33x"',
            'max_amplitudes."0.5x"',
            'max_amplitudes.1x',
            'max_amplitudes.2x',
            'max_amplitudes.3x',
            'max_amplitudes.4x',
            'max_amplitudes.sub',
            'full_amplitude',
            'full_frequency',
            'x_peak_to_peak_',
            'y_peak_to_peak_',
            'acquisition_time',
            'enterprise',
            'area',
            'site',
            'process',
            'unit',
            'component',
            'component_id',
            'rpm',
            'phase_x',
            'phase_y',
            'health_index',
            'operation_status',
            'rotation_direction',
            'neighbor_id',
            'id',
            'critical_speed',
          ],
          tier: null,
          totalVotes: 0,
          usageSummary: {
            date: '2026-03-26',
            weeklyStats: {
              percentileRank: 0,
              count: 0,
            },
            monthlyStats: {
              percentileRank: 0,
              count: 0,
            },
            dailyStats: {
              percentileRank: 0,
              count: 0,
            },
          },
          id: '989ee883-7ee4-4cbd-9396-1ea9f3a784c4',
          columnDescriptionStatus: 'INCOMPLETE',
          upstreamEntityRelationship: [],
          updatedAt: 1762155085011,
          columnNamesFuzzy:
            'amplitude_x amplitude_y frequency bandwidth bandwidth."0.07x" bandwidth."0.1x" bandwidth."0.33x" bandwidth."0.5x" bandwidth.1x bandwidth.2x bandwidth.3x bandwidth.4x bandwidth.sub max_amplitudes max_amplitudes."0.07x" max_amplitudes."0.1x" max_amplitudes."0.33x" max_amplitudes."0.5x" max_amplitudes.1x max_amplitudes.2x max_amplitudes.3x max_amplitudes.4x max_amplitudes.sub full_amplitude full_frequency x_peak_to_peak_ y_peak_to_peak_ acquisition_time enterprise area site process unit component component_id rpm phase_x phase_y health_index operation_status rotation_direction neighbor_id id critical_speed',
          descriptionSources: {
            Manual: 23,
          },
          updatedBy: 'jaejun.lee',
          entityType: 'table',
          domains: [],
          dataProducts: [],
          fullyQualifiedName: 'gold-iceberg.gold.g_turbo.gsp_ecms1_feature_preprocessed',
          version: 0.4,
          queries: [],
          certification: {
            tagLabel: {
              tagFQN: 'Certification.Gold',
              name: 'Gold',
              labelType: 'Manual',
              description: 'Gold certified Data Asset',
              style: {
                color: '#FFD700',
                iconURL: 'GoldCertification.svg',
              },
              source: 'Classification',
              state: 'Confirmed',
            },
          },
          tags: [
            {
              tagFQN: 'Equipment Type.터빈',
              name: '터빈',
              displayName: '터빈',
              description: '터빈 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
            {
              tagFQN: 'Equipment Type.CNC_Lathe',
              name: 'CNC_Lathe',
              displayName: 'CNC Lathe',
              description: 'CNC 선반 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
          ],
          terms: [
            {
              id: 'term-feature-engineering',
              type: 'glossaryTerm',
              name: 'FeatureEngineering',
              displayName: '피처 엔지니어링',
              fullyQualifiedName: 'DataManagement.FeatureEngineering',
              deleted: false,
            },
            {
              id: 'term-vibration',
              type: 'glossaryTerm',
              name: 'Vibration',
              displayName: '진동',
              fullyQualifiedName: 'Manufacturing.Vibration',
              deleted: false,
            },
          ],
          sourceHash: '37f2792bc7f03f21601b5f5b9bc0f86a',
          followers: [],
          deleted: false,
          service: {
            deleted: false,
            displayName: 'gold-iceberg',
            name: 'gold-iceberg',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>Gold Tier Iceberg</p></li></ul><p></p>',
            id: '877df342-f2d1-478c-81ea-5828e89c830e',
            type: 'databaseService',
            fullyQualifiedName: 'gold-iceberg',
          },
          name: 'gsp_ecms1_feature_preprocessed',
          processedLineage: false,
          tagSources: {},
          upstreamLineage: [
            {
              createdAt: 1772155678711,
              updatedBy: 'jaejun.lee',
              fromEntity: {
                id: '12b2fbff-74e4-4a77-845f-b81370f18b18',
                fullyQualifiedName: 'silver-iceberg.silver.g_turbo.gsp_ecms1_config',
                type: 'table',
                fqnHash:
                  '655f8a2d535e8834f62cae4d39557265.97f014516561ef487ec368d6158eb3f4.5df9be687e674cc4273916ac1fa9a834.f4a9ee0403e90e3be45fe1804ca0a72e',
              },
              createdBy: 'jaejun.lee',
              docId:
                'silver-iceberg.silver.g_turbo.gsp_ecms1_config--->gold-iceberg.gold.g_turbo.gsp_ecms1_feature_preprocessed',
              docUniqueId: '12b2fbff-74e4-4a77-845f-b81370f18b18--->989ee883-7ee4-4cbd-9396-1ea9f3a784c4',
              source: 'Manual',
              updatedAt: 1772155678711,
            },
            {
              createdAt: 1772155680589,
              updatedBy: 'jaejun.lee',
              fromEntity: {
                id: '9d0a653f-2511-4a3f-8650-320c3f08f584',
                fullyQualifiedName: 'silver-iceberg.silver.g_turbo.gsp_ecms1_waveform_preprocessed',
                type: 'table',
                fqnHash:
                  '655f8a2d535e8834f62cae4d39557265.97f014516561ef487ec368d6158eb3f4.5df9be687e674cc4273916ac1fa9a834.2eee204fc5d8da7e5f91c43d5565a4d6',
              },
              createdBy: 'jaejun.lee',
              docId:
                'silver-iceberg.silver.g_turbo.gsp_ecms1_waveform_preprocessed--->gold-iceberg.gold.g_turbo.gsp_ecms1_feature_preprocessed',
              docUniqueId: '9d0a653f-2511-4a3f-8650-320c3f08f584--->989ee883-7ee4-4cbd-9396-1ea9f3a784c4',
              source: 'Manual',
              updatedAt: 1772155680589,
            },
          ],
          locationPath: null,
          fqnParts: [
            'gold',
            'g_turbo',
            'gold-iceberg.gold.g_turbo',
            'gold.g_turbo.gsp_ecms1_feature_preprocessed',
            'gold-iceberg.gold.g_turbo.gsp_ecms1_feature_preprocessed',
            'g_turbo.gsp_ecms1_feature_preprocessed',
            'gold-iceberg',
            'gold-iceberg.gold',
            'gold.g_turbo',
          ],
        },
        sort: [0],
      },
      {
        _index: 'table_search_index',
        _id: 'bfe82951-0e52-4e4c-a9af-af0c9a239b89',
        _score: null,
        _source: {
          databaseSchema: {
            deleted: false,
            displayName: 'g_turbo',
            name: 'g_turbo',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>가디원 터보 연구 &amp; 개발에 사용되는 데이터 마트</p></li></ul><p></p>',
            id: '504b65ec-820d-4cc1-b1c3-e5b94b2e56fe',
            type: 'databaseSchema',
            fullyQualifiedName: 'gold-iceberg.gold.g_turbo',
          },
          serviceType: 'Iceberg',
          displayName: 'kmp_ecms_feature_preprocessed',
          schemaDefinition: null,
          description:
            '<ul class="om-list-disc"><li class="om-leading-normal"><p>KMP 신보령 Feature 데이터</p></li></ul><p></p>',
          owners: [
            {
              deleted: false,
              displayName: 'DI',
              inherited: true,
              name: 'DI',
              description:
                '<ul class="om-list-disc"><li class="om-leading-normal"><p>데이터 과학자, 분석가 소속 팀</p></li></ul><p></p>',
              id: '3b28a5be-4517-48f0-84f4-01ae147493bd',
              type: 'team',
              fullyQualifiedName: 'DI',
            },
          ],
          tierSources: {},
          fqnHash:
            '2870b486fb213438a92f4180af3df4a9.e07e81c20cf5935f5225765f0af81755.5df9be687e674cc4273916ac1fa9a834.c523b700fa607c2badeba1e5e2775545',
          customMetrics: [],
          tableType: 'Regular',
          database: {
            deleted: false,
            displayName: 'gold',
            name: 'gold',
            id: '1d7f528b-4bfd-4d35-b2ba-628d983931bf',
            type: 'database',
            fullyQualifiedName: 'gold-iceberg.gold',
          },
          descriptionStatus: 'COMPLETE',
          columnNames: [
            'amplitude_x',
            'amplitude_y',
            'frequency',
            'bandwidth',
            'bandwidth."0.07x"',
            'bandwidth."0.1x"',
            'bandwidth."0.33x"',
            'bandwidth."0.5x"',
            'bandwidth.1x',
            'bandwidth.2x',
            'bandwidth.3x',
            'bandwidth.4x',
            'bandwidth.sub',
            'max_amplitudes',
            'max_amplitudes."0.07x"',
            'max_amplitudes."0.1x"',
            'max_amplitudes."0.33x"',
            'max_amplitudes."0.5x"',
            'max_amplitudes.1x',
            'max_amplitudes.2x',
            'max_amplitudes.3x',
            'max_amplitudes.4x',
            'max_amplitudes.sub',
            'full_amplitude',
            'full_frequency',
            'x_peak_to_peak',
            'y_peak_to_peak',
            'acquisition_time',
            'enterprise',
            'area',
            'site',
            'process',
            'unit',
            'component',
            'component_id',
            'rpm',
            'phase_x',
            'phase_y',
            'health_index',
            'operation_status',
            'rotation_direction',
            'neighbor_id',
            'id',
            'critical_speed',
          ],
          tier: null,
          totalVotes: 0,
          usageSummary: {
            date: '2026-03-26',
            weeklyStats: {
              percentileRank: 0,
              count: 0,
            },
            monthlyStats: {
              percentileRank: 0,
              count: 0,
            },
            dailyStats: {
              percentileRank: 0,
              count: 0,
            },
          },
          id: 'bfe82951-0e52-4e4c-a9af-af0c9a239b89',
          columnDescriptionStatus: 'INCOMPLETE',
          upstreamEntityRelationship: [],
          updatedAt: 1764057402536,
          columnNamesFuzzy:
            'amplitude_x amplitude_y frequency bandwidth bandwidth."0.07x" bandwidth."0.1x" bandwidth."0.33x" bandwidth."0.5x" bandwidth.1x bandwidth.2x bandwidth.3x bandwidth.4x bandwidth.sub max_amplitudes max_amplitudes."0.07x" max_amplitudes."0.1x" max_amplitudes."0.33x" max_amplitudes."0.5x" max_amplitudes.1x max_amplitudes.2x max_amplitudes.3x max_amplitudes.4x max_amplitudes.sub full_amplitude full_frequency x_peak_to_peak y_peak_to_peak acquisition_time enterprise area site process unit component component_id rpm phase_x phase_y health_index operation_status rotation_direction neighbor_id id critical_speed',
          descriptionSources: {
            Manual: 1,
          },
          updatedBy: 'jaejun.lee',
          entityType: 'table',
          domains: [],
          dataProducts: [],
          fullyQualifiedName: 'gold-iceberg.gold.g_turbo.kmp_ecms_feature_preprocessed',
          version: 0.2,
          queries: [],
          certification: {
            tagLabel: {
              tagFQN: 'Certification.Gold',
              name: 'Gold',
              labelType: 'Manual',
              description: 'Gold certified Data Asset',
              style: {
                color: '#FFD700',
                iconURL: 'GoldCertification.svg',
              },
              source: 'Classification',
              state: 'Confirmed',
            },
          },
          tags: [
            {
              tagFQN: 'Equipment Type.터빈',
              name: '터빈',
              displayName: '터빈',
              description: '터빈 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
          ],
          terms: [
            {
              id: 'term-feature-engineering',
              type: 'glossaryTerm',
              name: 'FeatureEngineering',
              displayName: '피처 엔지니어링',
              fullyQualifiedName: 'DataManagement.FeatureEngineering',
              deleted: false,
            },
            {
              id: 'term-vibration',
              type: 'glossaryTerm',
              name: 'Vibration',
              displayName: '진동',
              fullyQualifiedName: 'Manufacturing.Vibration',
              deleted: false,
            },
          ],
          sourceHash: 'f857b3037070b1d371526104165be6ba',
          followers: [],
          deleted: false,
          service: {
            deleted: false,
            displayName: 'gold-iceberg',
            name: 'gold-iceberg',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>Gold Tier Iceberg</p></li></ul><p></p>',
            id: '877df342-f2d1-478c-81ea-5828e89c830e',
            type: 'databaseService',
            fullyQualifiedName: 'gold-iceberg',
          },
          name: 'kmp_ecms_feature_preprocessed',
          processedLineage: false,
          tagSources: {},
          upstreamLineage: [
            {
              createdAt: 1772156140259,
              updatedBy: 'jaejun.lee',
              fromEntity: {
                id: '30d3a43b-7036-4911-8626-69904bec7dbd',
                fullyQualifiedName: 'silver-iceberg.silver.g_turbo.kmp_ecms_waveform_preprocessed',
                type: 'table',
                fqnHash:
                  '655f8a2d535e8834f62cae4d39557265.97f014516561ef487ec368d6158eb3f4.5df9be687e674cc4273916ac1fa9a834.a085a82b4e6c8fa8b2514053778bb175',
              },
              createdBy: 'jaejun.lee',
              docId:
                'silver-iceberg.silver.g_turbo.kmp_ecms_waveform_preprocessed--->gold-iceberg.gold.g_turbo.kmp_ecms_feature_preprocessed',
              docUniqueId: '30d3a43b-7036-4911-8626-69904bec7dbd--->bfe82951-0e52-4e4c-a9af-af0c9a239b89',
              source: 'Manual',
              updatedAt: 1772156140259,
            },
            {
              createdAt: 1768881434131,
              updatedBy: 'jaejun.lee',
              fromEntity: {
                id: 'ca1c2aeb-84cb-4186-8686-620d7c5bcc4f',
                fullyQualifiedName: 'silver-iceberg.silver.g_turbo.kmp_ecms_config',
                type: 'table',
                fqnHash:
                  '655f8a2d535e8834f62cae4d39557265.97f014516561ef487ec368d6158eb3f4.5df9be687e674cc4273916ac1fa9a834.eb7c4bbbdca2f7f30a45039f4a5377c5',
              },
              createdBy: 'jaejun.lee',
              docId:
                'silver-iceberg.silver.g_turbo.kmp_ecms_config--->gold-iceberg.gold.g_turbo.kmp_ecms_feature_preprocessed',
              docUniqueId: 'ca1c2aeb-84cb-4186-8686-620d7c5bcc4f--->bfe82951-0e52-4e4c-a9af-af0c9a239b89',
              source: 'Manual',
              updatedAt: 1768881434131,
            },
          ],
          locationPath: null,
          fqnParts: [
            'gold',
            'g_turbo',
            'gold-iceberg.gold.g_turbo',
            'gold-iceberg.gold.g_turbo.kmp_ecms_feature_preprocessed',
            'g_turbo.kmp_ecms_feature_preprocessed',
            'gold-iceberg',
            'gold-iceberg.gold',
            'gold.g_turbo',
            'gold.g_turbo.kmp_ecms_feature_preprocessed',
          ],
        },
        sort: [0],
      },
      {
        _index: 'table_search_index',
        _id: '9c60daac-b28a-4e7f-b183-92202f188a7e',
        _score: null,
        _source: {
          databaseSchema: {
            deleted: false,
            displayName: 'g_turbo',
            name: 'g_turbo',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>가디원 터보 연구 &amp; 개발에 사용되는 데이터 마트</p></li></ul><p></p>',
            id: '504b65ec-820d-4cc1-b1c3-e5b94b2e56fe',
            type: 'databaseSchema',
            fullyQualifiedName: 'gold-iceberg.gold.g_turbo',
          },
          serviceType: 'Iceberg',
          displayName: 'kmp_ecms_diagnosis_results',
          schemaDefinition: null,
          description:
            '<ul class="om-list-disc"><li class="om-leading-normal"><p>KMP ECMS 기반 진단 결과</p></li></ul><p></p>',
          owners: [
            {
              deleted: false,
              displayName: 'DI',
              inherited: true,
              name: 'DI',
              description:
                '<ul class="om-list-disc"><li class="om-leading-normal"><p>데이터 과학자, 분석가 소속 팀</p></li></ul><p></p>',
              id: '3b28a5be-4517-48f0-84f4-01ae147493bd',
              type: 'team',
              fullyQualifiedName: 'DI',
            },
          ],
          tierSources: {},
          fqnHash:
            '2870b486fb213438a92f4180af3df4a9.e07e81c20cf5935f5225765f0af81755.5df9be687e674cc4273916ac1fa9a834.0aa789ac16cb6cb8bff0552c6b10cffb',
          customMetrics: [],
          tableType: 'Regular',
          database: {
            deleted: false,
            displayName: 'gold',
            name: 'gold',
            id: '1d7f528b-4bfd-4d35-b2ba-628d983931bf',
            type: 'database',
            fullyQualifiedName: 'gold-iceberg.gold',
          },
          descriptionStatus: 'COMPLETE',
          columnNames: [
            'timestamp',
            'brg_id',
            'between_phase',
            'phase_time',
            'diag_result',
            'diag_result.cavitation',
            'diag_result.full_rub',
            'diag_result.gas_whirl',
            'diag_result.mass_loss',
            'diag_result.misalignment',
            'diag_result.oil_whirl',
            'diag_result.partial_rub',
            'diag_result.rotor_bow',
            'diag_result.stall',
            'diag_result.steam_whirl',
            'diag_result.surge',
            'diag_result.thermal_growth',
            'diag_result.thermal_sensitivity',
            'diag_result.unbalance',
          ],
          tier: null,
          totalVotes: 0,
          usageSummary: {
            date: '2026-03-26',
            weeklyStats: {
              percentileRank: 0,
              count: 0,
            },
            monthlyStats: {
              percentileRank: 0,
              count: 0,
            },
            dailyStats: {
              percentileRank: 0,
              count: 0,
            },
          },
          id: '9c60daac-b28a-4e7f-b183-92202f188a7e',
          columnDescriptionStatus: 'INCOMPLETE',
          upstreamEntityRelationship: [],
          updatedAt: 1764206485867,
          columnNamesFuzzy:
            'timestamp brg_id between_phase phase_time diag_result diag_result.cavitation diag_result.full_rub diag_result.gas_whirl diag_result.mass_loss diag_result.misalignment diag_result.oil_whirl diag_result.partial_rub diag_result.rotor_bow diag_result.stall diag_result.steam_whirl diag_result.surge diag_result.thermal_growth diag_result.thermal_sensitivity diag_result.unbalance',
          descriptionSources: {
            Manual: 1,
          },
          updatedBy: 'jaejun.lee',
          entityType: 'table',
          domains: [],
          dataProducts: [],
          fullyQualifiedName: 'gold-iceberg.gold.g_turbo.kmp_ecms_diagnosis_results',
          version: 0.2,
          queries: [],
          certification: {
            tagLabel: {
              tagFQN: 'Certification.Gold',
              name: 'Gold',
              labelType: 'Manual',
              description: 'Gold certified Data Asset',
              style: {
                color: '#FFD700',
                iconURL: 'GoldCertification.svg',
              },
              source: 'Classification',
              state: 'Confirmed',
            },
          },
          tags: [
            {
              tagFQN: 'Equipment Type.터빈',
              name: '터빈',
              displayName: '터빈',
              description: '터빈 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
          ],
          terms: [
            {
              id: 'term-machine-learning',
              type: 'glossaryTerm',
              name: 'MachineLearning',
              displayName: '머신러닝',
              fullyQualifiedName: 'DataManagement.MachineLearning',
              deleted: false,
            },
            {
              id: 'term-predictive-maintenance',
              type: 'glossaryTerm',
              name: 'PredictiveMaintenance',
              displayName: '예지보전',
              fullyQualifiedName: 'Manufacturing.PredictiveMaintenance',
              deleted: false,
            },
            {
              id: 'term-anomaly-detection',
              type: 'glossaryTerm',
              name: 'AnomalyDetection',
              displayName: '이상 탐지',
              fullyQualifiedName: 'Quality.AnomalyDetection',
              deleted: false,
            },
          ],
          sourceHash: 'f12ef776d74d4a9c7967f64d9dd66093',
          followers: [],
          deleted: false,
          service: {
            deleted: false,
            displayName: 'gold-iceberg',
            name: 'gold-iceberg',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>Gold Tier Iceberg</p></li></ul><p></p>',
            id: '877df342-f2d1-478c-81ea-5828e89c830e',
            type: 'databaseService',
            fullyQualifiedName: 'gold-iceberg',
          },
          name: 'kmp_ecms_diagnosis_results',
          processedLineage: false,
          tagSources: {},
          upstreamLineage: [
            {
              createdAt: 1768811114284,
              updatedBy: 'jaejun.lee',
              fromEntity: {
                id: 'bfe82951-0e52-4e4c-a9af-af0c9a239b89',
                fullyQualifiedName: 'gold-iceberg.gold.g_turbo.kmp_ecms_feature_preprocessed',
                type: 'table',
                fqnHash:
                  '2870b486fb213438a92f4180af3df4a9.e07e81c20cf5935f5225765f0af81755.5df9be687e674cc4273916ac1fa9a834.c523b700fa607c2badeba1e5e2775545',
              },
              createdBy: 'jaejun.lee',
              docId:
                'gold-iceberg.gold.g_turbo.kmp_ecms_feature_preprocessed--->gold-iceberg.gold.g_turbo.kmp_ecms_diagnosis_results',
              docUniqueId: 'bfe82951-0e52-4e4c-a9af-af0c9a239b89--->9c60daac-b28a-4e7f-b183-92202f188a7e',
              source: 'Manual',
              updatedAt: 1768811114284,
            },
          ],
          locationPath: null,
          fqnParts: [
            'gold',
            'gold-iceberg.gold.g_turbo.kmp_ecms_diagnosis_results',
            'g_turbo',
            'gold-iceberg.gold.g_turbo',
            'g_turbo.kmp_ecms_diagnosis_results',
            'gold.g_turbo.kmp_ecms_diagnosis_results',
            'gold-iceberg',
            'gold-iceberg.gold',
            'gold.g_turbo',
          ],
        },
        sort: [0],
      },
      {
        _index: 'table_search_index',
        _id: 'de411cab-abcd-4712-b662-f94e80ee95ca',
        _score: null,
        _source: {
          databaseSchema: {
            deleted: false,
            displayName: 'g_turbo',
            name: 'g_turbo',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>가디원 터보 연구 &amp; 개발에 사용되는 데이터 마트</p></li></ul><p></p>',
            id: '504b65ec-820d-4cc1-b1c3-e5b94b2e56fe',
            type: 'databaseSchema',
            fullyQualifiedName: 'gold-iceberg.gold.g_turbo',
          },
          serviceType: 'Iceberg',
          displayName: 'hanwha_impact_feature_preprocessed',
          schemaDefinition: null,
          description:
            '<ul class="om-list-disc"><li class="om-leading-normal"><p>Hanwha Impact feature 데이터</p></li></ul><p></p>',
          owners: [
            {
              deleted: false,
              displayName: 'DI',
              inherited: true,
              name: 'DI',
              description:
                '<ul class="om-list-disc"><li class="om-leading-normal"><p>데이터 과학자, 분석가 소속 팀</p></li></ul><p></p>',
              id: '3b28a5be-4517-48f0-84f4-01ae147493bd',
              type: 'team',
              fullyQualifiedName: 'DI',
            },
          ],
          tierSources: {},
          fqnHash:
            '2870b486fb213438a92f4180af3df4a9.e07e81c20cf5935f5225765f0af81755.5df9be687e674cc4273916ac1fa9a834.67c6f87a16ffba9e49f317013ba2400b',
          customMetrics: [],
          tableType: 'Regular',
          database: {
            deleted: false,
            displayName: 'gold',
            name: 'gold',
            id: '1d7f528b-4bfd-4d35-b2ba-628d983931bf',
            type: 'database',
            fullyQualifiedName: 'gold-iceberg.gold',
          },
          descriptionStatus: 'COMPLETE',
          columnNames: [
            'amplitude_x',
            'amplitude_y',
            'frequency',
            'bandwidth',
            'bandwidth."0.07x"',
            'bandwidth."0.1x"',
            'bandwidth."0.33x"',
            'bandwidth."0.5x"',
            'bandwidth.1x',
            'bandwidth.2x',
            'bandwidth.3x',
            'bandwidth.4x',
            'bandwidth.sub',
            'max_amplitudes',
            'max_amplitudes."0.07x"',
            'max_amplitudes."0.1x"',
            'max_amplitudes."0.33x"',
            'max_amplitudes."0.5x"',
            'max_amplitudes.1x',
            'max_amplitudes.2x',
            'max_amplitudes.3x',
            'max_amplitudes.4x',
            'max_amplitudes.sub',
            'full_amplitude',
            'full_frequency',
            'x_peak_to_peak',
            'y_peak_to_peak',
            'acquisition_time',
            'enterprise',
            'area',
            'site',
            'process',
            'unit',
            'component',
            'component_id',
            'rpm',
            'phase_x',
            'phase_y',
            'health_index',
            'operation_status',
            'rotation_direction',
            'neighbor_id',
            'id',
            'critical_speed',
          ],
          tier: null,
          totalVotes: 0,
          usageSummary: {
            date: '2026-03-26',
            weeklyStats: {
              percentileRank: 0,
              count: 0,
            },
            monthlyStats: {
              percentileRank: 0,
              count: 0,
            },
            dailyStats: {
              percentileRank: 0,
              count: 0,
            },
          },
          id: 'de411cab-abcd-4712-b662-f94e80ee95ca',
          columnDescriptionStatus: 'INCOMPLETE',
          upstreamEntityRelationship: [],
          updatedAt: 1762155133146,
          columnNamesFuzzy:
            'amplitude_x amplitude_y frequency bandwidth bandwidth."0.07x" bandwidth."0.1x" bandwidth."0.33x" bandwidth."0.5x" bandwidth.1x bandwidth.2x bandwidth.3x bandwidth.4x bandwidth.sub max_amplitudes max_amplitudes."0.07x" max_amplitudes."0.1x" max_amplitudes."0.33x" max_amplitudes."0.5x" max_amplitudes.1x max_amplitudes.2x max_amplitudes.3x max_amplitudes.4x max_amplitudes.sub full_amplitude full_frequency x_peak_to_peak y_peak_to_peak acquisition_time enterprise area site process unit component component_id rpm phase_x phase_y health_index operation_status rotation_direction neighbor_id id critical_speed',
          descriptionSources: {
            Manual: 23,
          },
          updatedBy: 'jaejun.lee',
          entityType: 'table',
          domains: [],
          dataProducts: [],
          fullyQualifiedName: 'gold-iceberg.gold.g_turbo.hanwha_impact_feature_preprocessed',
          version: 0.3,
          queries: [],
          certification: {
            tagLabel: {
              tagFQN: 'Certification.Gold',
              name: 'Gold',
              labelType: 'Manual',
              description: 'Gold certified Data Asset',
              style: {
                color: '#FFD700',
                iconURL: 'GoldCertification.svg',
              },
              source: 'Classification',
              state: 'Confirmed',
            },
          },
          tags: [
            {
              tagFQN: 'Equipment Type.Furnace',
              name: 'Furnace',
              displayName: 'Furnace',
              description: '용광로 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
            {
              tagFQN: 'Equipment Type.사출기',
              name: '사출기',
              displayName: '사출기',
              description: '사출 성형 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
          ],
          terms: [
            {
              id: 'term-feature-engineering',
              type: 'glossaryTerm',
              name: 'FeatureEngineering',
              displayName: '피처 엔지니어링',
              fullyQualifiedName: 'DataManagement.FeatureEngineering',
              deleted: false,
            },
            {
              id: 'term-vibration',
              type: 'glossaryTerm',
              name: 'Vibration',
              displayName: '진동',
              fullyQualifiedName: 'Manufacturing.Vibration',
              deleted: false,
            },
          ],
          sourceHash: 'cbf7927c13604eca31087c2bafe9e7c7',
          followers: [],
          deleted: false,
          service: {
            deleted: false,
            displayName: 'gold-iceberg',
            name: 'gold-iceberg',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>Gold Tier Iceberg</p></li></ul><p></p>',
            id: '877df342-f2d1-478c-81ea-5828e89c830e',
            type: 'databaseService',
            fullyQualifiedName: 'gold-iceberg',
          },
          name: 'hanwha_impact_feature_preprocessed',
          processedLineage: false,
          tagSources: {},
          upstreamLineage: [
            {
              createdAt: 1772155967349,
              updatedBy: 'jaejun.lee',
              fromEntity: {
                id: '45ae3a26-7cce-45d6-abea-45c9cd8d43c2',
                fullyQualifiedName: 'silver-iceberg.silver.g_turbo.hanwha_impact_config',
                type: 'table',
                fqnHash:
                  '655f8a2d535e8834f62cae4d39557265.97f014516561ef487ec368d6158eb3f4.5df9be687e674cc4273916ac1fa9a834.861e82fef28c472e077018b2d6d37581',
              },
              createdBy: 'jaejun.lee',
              docId:
                'silver-iceberg.silver.g_turbo.hanwha_impact_config--->gold-iceberg.gold.g_turbo.hanwha_impact_feature_preprocessed',
              docUniqueId: '45ae3a26-7cce-45d6-abea-45c9cd8d43c2--->de411cab-abcd-4712-b662-f94e80ee95ca',
              source: 'Manual',
              updatedAt: 1772155967349,
            },
            {
              createdAt: 1772156014713,
              updatedBy: 'jaejun.lee',
              fromEntity: {
                id: 'b4ea86d4-1fc5-4580-9441-30a00e685a7c',
                fullyQualifiedName: 'silver-iceberg.silver.g_turbo.hanwha_impact_waveform_preprocessed',
                type: 'table',
                fqnHash:
                  '655f8a2d535e8834f62cae4d39557265.97f014516561ef487ec368d6158eb3f4.5df9be687e674cc4273916ac1fa9a834.b48a8b54732efede02ad9df226d1bbf6',
              },
              createdBy: 'jaejun.lee',
              docId:
                'silver-iceberg.silver.g_turbo.hanwha_impact_waveform_preprocessed--->gold-iceberg.gold.g_turbo.hanwha_impact_feature_preprocessed',
              docUniqueId: 'b4ea86d4-1fc5-4580-9441-30a00e685a7c--->de411cab-abcd-4712-b662-f94e80ee95ca',
              source: 'Manual',
              updatedAt: 1772156014713,
            },
          ],
          locationPath: null,
          fqnParts: [
            'gold',
            'g_turbo',
            'gold-iceberg.gold.g_turbo',
            'gold-iceberg.gold.g_turbo.hanwha_impact_feature_preprocessed',
            'g_turbo.hanwha_impact_feature_preprocessed',
            'gold-iceberg',
            'gold.g_turbo.hanwha_impact_feature_preprocessed',
            'gold-iceberg.gold',
            'gold.g_turbo',
          ],
        },
        sort: [0],
      },
      {
        _index: 'table_search_index',
        _id: '841509c0-f24c-4f52-b67b-317096b5b68d',
        _score: null,
        _source: {
          databaseSchema: {
            deleted: false,
            displayName: 'g_turbo',
            name: 'g_turbo',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>가디원 터보 연구 &amp; 개발에 사용되는 데이터 마트</p></li></ul><p></p>',
            id: '504b65ec-820d-4cc1-b1c3-e5b94b2e56fe',
            type: 'databaseSchema',
            fullyQualifiedName: 'gold-iceberg.gold.g_turbo',
          },
          serviceType: 'Iceberg',
          displayName: 'gsp_ecms1_diagnosis_result',
          schemaDefinition: null,
          description:
            '<ul class="om-list-disc"><li class="om-leading-normal"><p>GSP ECMS1 기반 진단 결과</p></li></ul><p></p>',
          owners: [
            {
              deleted: false,
              displayName: 'DI',
              inherited: true,
              name: 'DI',
              description:
                '<ul class="om-list-disc"><li class="om-leading-normal"><p>데이터 과학자, 분석가 소속 팀</p></li></ul><p></p>',
              id: '3b28a5be-4517-48f0-84f4-01ae147493bd',
              type: 'team',
              fullyQualifiedName: 'DI',
            },
          ],
          tierSources: {},
          fqnHash:
            '2870b486fb213438a92f4180af3df4a9.e07e81c20cf5935f5225765f0af81755.5df9be687e674cc4273916ac1fa9a834.4f17d1bd3c823a57e0a702c16555d4fa',
          customMetrics: [],
          tableType: 'Regular',
          database: {
            deleted: false,
            displayName: 'gold',
            name: 'gold',
            id: '1d7f528b-4bfd-4d35-b2ba-628d983931bf',
            type: 'database',
            fullyQualifiedName: 'gold-iceberg.gold',
          },
          descriptionStatus: 'COMPLETE',
          columnNames: [
            'timestamp',
            'brg_id',
            'between_phase',
            'phase_time',
            'diag_result',
            'diag_result.cavitation',
            'diag_result.full_rub',
            'diag_result.gas_whirl',
            'diag_result.mass_loss',
            'diag_result.misalignment',
            'diag_result.oil_whirl',
            'diag_result.partial_rub',
            'diag_result.rotor_bow',
            'diag_result.stall',
            'diag_result.steam_whirl',
            'diag_result.surge',
            'diag_result.thermal_growth',
            'diag_result.thermal_sensitivity',
            'diag_result.unbalance',
          ],
          tier: null,
          totalVotes: 0,
          usageSummary: {
            date: '2026-03-26',
            weeklyStats: {
              percentileRank: 0,
              count: 0,
            },
            monthlyStats: {
              percentileRank: 0,
              count: 0,
            },
            dailyStats: {
              percentileRank: 0,
              count: 0,
            },
          },
          id: '841509c0-f24c-4f52-b67b-317096b5b68d',
          columnDescriptionStatus: 'COMPLETE',
          upstreamEntityRelationship: [],
          updatedAt: 1762231149327,
          columnNamesFuzzy:
            'timestamp brg_id between_phase phase_time diag_result diag_result.cavitation diag_result.full_rub diag_result.gas_whirl diag_result.mass_loss diag_result.misalignment diag_result.oil_whirl diag_result.partial_rub diag_result.rotor_bow diag_result.stall diag_result.steam_whirl diag_result.surge diag_result.thermal_growth diag_result.thermal_sensitivity diag_result.unbalance',
          descriptionSources: {
            Manual: 6,
          },
          updatedBy: 'jaejun.lee',
          entityType: 'table',
          domains: [],
          dataProducts: [],
          fullyQualifiedName: 'gold-iceberg.gold.g_turbo.gsp_ecms1_diagnosis_result',
          version: 0.5,
          queries: [],
          certification: {
            tagLabel: {
              tagFQN: 'Certification.Gold',
              name: 'Gold',
              labelType: 'Manual',
              description: 'Gold certified Data Asset',
              style: {
                color: '#FFD700',
                iconURL: 'GoldCertification.svg',
              },
              source: 'Classification',
              state: 'Confirmed',
            },
          },
          tags: [
            {
              tagFQN: 'Equipment Type.CNC_Lathe',
              name: 'CNC_Lathe',
              displayName: 'CNC Lathe',
              description: 'CNC 선반 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
            {
              tagFQN: 'Equipment Type.터빈',
              name: '터빈',
              displayName: '터빈',
              description: '터빈 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
          ],
          terms: [
            {
              id: 'term-machine-learning',
              type: 'glossaryTerm',
              name: 'MachineLearning',
              displayName: '머신러닝',
              fullyQualifiedName: 'DataManagement.MachineLearning',
              deleted: false,
            },
            {
              id: 'term-predictive-maintenance',
              type: 'glossaryTerm',
              name: 'PredictiveMaintenance',
              displayName: '예지보전',
              fullyQualifiedName: 'Manufacturing.PredictiveMaintenance',
              deleted: false,
            },
          ],
          sourceHash: '1de063f91c17f8f4e390f9080464c9d9',
          followers: [],
          deleted: false,
          service: {
            deleted: false,
            displayName: 'gold-iceberg',
            name: 'gold-iceberg',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>Gold Tier Iceberg</p></li></ul><p></p>',
            id: '877df342-f2d1-478c-81ea-5828e89c830e',
            type: 'databaseService',
            fullyQualifiedName: 'gold-iceberg',
          },
          name: 'gsp_ecms1_diagnosis_result',
          processedLineage: false,
          tagSources: {},
          upstreamLineage: [
            {
              createdAt: 1772155682987,
              updatedBy: 'jaejun.lee',
              fromEntity: {
                id: '989ee883-7ee4-4cbd-9396-1ea9f3a784c4',
                fullyQualifiedName: 'gold-iceberg.gold.g_turbo.gsp_ecms1_feature_preprocessed',
                type: 'table',
                fqnHash:
                  '2870b486fb213438a92f4180af3df4a9.e07e81c20cf5935f5225765f0af81755.5df9be687e674cc4273916ac1fa9a834.1b69903a92956ee3786479ce3d8a431e',
              },
              createdBy: 'jaejun.lee',
              docId:
                'gold-iceberg.gold.g_turbo.gsp_ecms1_feature_preprocessed--->gold-iceberg.gold.g_turbo.gsp_ecms1_diagnosis_result',
              docUniqueId: '989ee883-7ee4-4cbd-9396-1ea9f3a784c4--->841509c0-f24c-4f52-b67b-317096b5b68d',
              source: 'Manual',
              updatedAt: 1772155682987,
            },
          ],
          locationPath: null,
          fqnParts: [
            'gold',
            'g_turbo',
            'gold-iceberg.gold.g_turbo',
            'gold-iceberg.gold.g_turbo.gsp_ecms1_diagnosis_result',
            'gold-iceberg',
            'g_turbo.gsp_ecms1_diagnosis_result',
            'gold.g_turbo.gsp_ecms1_diagnosis_result',
            'gold-iceberg.gold',
            'gold.g_turbo',
          ],
        },
        sort: [0],
      },
      {
        _index: 'table_search_index',
        _id: '072d6802-fa44-48fa-8e98-27b0b97d0ea6',
        _score: null,
        _source: {
          databaseSchema: {
            deleted: false,
            displayName: 'g_turbo',
            name: 'g_turbo',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>가디원 터보 연구 &amp; 개발에 사용되는 데이터 마트</p></li></ul><p></p>',
            id: '504b65ec-820d-4cc1-b1c3-e5b94b2e56fe',
            type: 'databaseSchema',
            fullyQualifiedName: 'gold-iceberg.gold.g_turbo',
          },
          serviceType: 'Iceberg',
          displayName: 'hanwha_impact_diagnosis_results',
          schemaDefinition: null,
          description:
            '<ul class="om-list-disc"><li class="om-leading-normal"><p>한화 임팩트 데이터 진단 결과</p></li></ul><p></p>',
          owners: [
            {
              deleted: false,
              displayName: 'DI',
              inherited: true,
              name: 'DI',
              description:
                '<ul class="om-list-disc"><li class="om-leading-normal"><p>데이터 과학자, 분석가 소속 팀</p></li></ul><p></p>',
              id: '3b28a5be-4517-48f0-84f4-01ae147493bd',
              type: 'team',
              fullyQualifiedName: 'DI',
            },
          ],
          tierSources: {},
          fqnHash:
            '2870b486fb213438a92f4180af3df4a9.e07e81c20cf5935f5225765f0af81755.5df9be687e674cc4273916ac1fa9a834.9198d9aea1e9a7ebc4412e15f3b9584b',
          customMetrics: [],
          tableType: 'Regular',
          database: {
            deleted: false,
            displayName: 'gold',
            name: 'gold',
            id: '1d7f528b-4bfd-4d35-b2ba-628d983931bf',
            type: 'database',
            fullyQualifiedName: 'gold-iceberg.gold',
          },
          descriptionStatus: 'COMPLETE',
          columnNames: [
            'timestamp',
            'brg_id',
            'between_phase',
            'phase_time',
            'diag_result',
            'diag_result.cavitation',
            'diag_result.full_rub',
            'diag_result.gas_whirl',
            'diag_result.mass_loss',
            'diag_result.misalignment',
            'diag_result.oil_whirl',
            'diag_result.partial_rub',
            'diag_result.rotor_bow',
            'diag_result.stall',
            'diag_result.steam_whirl',
            'diag_result.surge',
            'diag_result.thermal_growth',
            'diag_result.thermal_sensitivity',
            'diag_result.unbalance',
          ],
          tier: null,
          totalVotes: 0,
          usageSummary: {
            date: '2026-03-26',
            weeklyStats: {
              percentileRank: 0,
              count: 0,
            },
            monthlyStats: {
              percentileRank: 0,
              count: 0,
            },
            dailyStats: {
              percentileRank: 0,
              count: 0,
            },
          },
          id: '072d6802-fa44-48fa-8e98-27b0b97d0ea6',
          columnDescriptionStatus: 'COMPLETE',
          upstreamEntityRelationship: [],
          updatedAt: 1762231140003,
          columnNamesFuzzy:
            'timestamp brg_id between_phase phase_time diag_result diag_result.cavitation diag_result.full_rub diag_result.gas_whirl diag_result.mass_loss diag_result.misalignment diag_result.oil_whirl diag_result.partial_rub diag_result.rotor_bow diag_result.stall diag_result.steam_whirl diag_result.surge diag_result.thermal_growth diag_result.thermal_sensitivity diag_result.unbalance',
          descriptionSources: {
            Manual: 6,
          },
          updatedBy: 'jaejun.lee',
          entityType: 'table',
          domains: [],
          dataProducts: [],
          fullyQualifiedName: 'gold-iceberg.gold.g_turbo.hanwha_impact_diagnosis_results',
          version: 0.3,
          queries: [],
          certification: {
            tagLabel: {
              tagFQN: 'Certification.Gold',
              name: 'Gold',
              labelType: 'Manual',
              description: 'Gold certified Data Asset',
              style: {
                color: '#FFD700',
                iconURL: 'GoldCertification.svg',
              },
              source: 'Classification',
              state: 'Confirmed',
            },
          },
          tags: [
            {
              tagFQN: 'Equipment Type.Furnace',
              name: 'Furnace',
              displayName: 'Furnace',
              description: '용광로 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
            {
              tagFQN: 'Equipment Type.터빈',
              name: '터빈',
              displayName: '터빈',
              description: '터빈 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
          ],
          terms: [
            {
              id: 'term-machine-learning',
              type: 'glossaryTerm',
              name: 'MachineLearning',
              displayName: '머신러닝',
              fullyQualifiedName: 'DataManagement.MachineLearning',
              deleted: false,
            },
            {
              id: 'term-anomaly-detection',
              type: 'glossaryTerm',
              name: 'AnomalyDetection',
              displayName: '이상 탐지',
              fullyQualifiedName: 'Quality.AnomalyDetection',
              deleted: false,
            },
          ],
          sourceHash: '37537524cdcbc368c6c5991d941ffee7',
          followers: [],
          deleted: false,
          service: {
            deleted: false,
            displayName: 'gold-iceberg',
            name: 'gold-iceberg',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>Gold Tier Iceberg</p></li></ul><p></p>',
            id: '877df342-f2d1-478c-81ea-5828e89c830e',
            type: 'databaseService',
            fullyQualifiedName: 'gold-iceberg',
          },
          name: 'hanwha_impact_diagnosis_results',
          processedLineage: false,
          tagSources: {},
          upstreamLineage: [
            {
              createdAt: 1772155956367,
              updatedBy: 'jaejun.lee',
              fromEntity: {
                id: 'de411cab-abcd-4712-b662-f94e80ee95ca',
                fullyQualifiedName: 'gold-iceberg.gold.g_turbo.hanwha_impact_feature_preprocessed',
                type: 'table',
                fqnHash:
                  '2870b486fb213438a92f4180af3df4a9.e07e81c20cf5935f5225765f0af81755.5df9be687e674cc4273916ac1fa9a834.67c6f87a16ffba9e49f317013ba2400b',
              },
              createdBy: 'jaejun.lee',
              docId:
                'gold-iceberg.gold.g_turbo.hanwha_impact_feature_preprocessed--->gold-iceberg.gold.g_turbo.hanwha_impact_diagnosis_results',
              docUniqueId: 'de411cab-abcd-4712-b662-f94e80ee95ca--->072d6802-fa44-48fa-8e98-27b0b97d0ea6',
              source: 'Manual',
              updatedAt: 1772155956367,
            },
          ],
          locationPath: null,
          fqnParts: [
            'gold',
            'g_turbo',
            'gold.g_turbo.hanwha_impact_diagnosis_results',
            'gold-iceberg.gold.g_turbo',
            'g_turbo.hanwha_impact_diagnosis_results',
            'gold-iceberg.gold.g_turbo.hanwha_impact_diagnosis_results',
            'gold-iceberg',
            'gold-iceberg.gold',
            'gold.g_turbo',
          ],
        },
        sort: [0],
      },
    ],
  },
  aggregations: {
    'sterms#serviceType': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [
        {
          key: 'iceberg',
          doc_count: 6,
        },
      ],
    },
    'sterms#databaseSchema.name.keyword': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [
        {
          key: 'g_turbo',
          doc_count: 6,
        },
      ],
    },
    'sterms#tags.tagFQN': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [],
    },
    'sterms#databaseSchema.displayName': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [
        {
          key: 'g_turbo',
          doc_count: 6,
        },
      ],
    },
    'sterms#entityType': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [
        {
          key: 'table',
          doc_count: 6,
        },
      ],
    },
    'sterms#entityType.keyword': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [
        {
          key: 'table',
          doc_count: 6,
        },
      ],
    },
    'sterms#domain.displayName.keyword': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [],
    },
    'sterms#tier.tagFQN': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [],
    },
    'sterms#service.displayName.keyword': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [
        {
          key: 'gold-iceberg',
          doc_count: 6,
        },
      ],
    },
    'sterms#database.displayName': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [
        {
          key: 'gold',
          doc_count: 6,
        },
      ],
    },
    'sterms#database.name.keyword': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [
        {
          key: 'gold',
          doc_count: 6,
        },
      ],
    },
    'sterms#certification.tagLabel.tagFQN': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [],
    },
    'sterms#owners.displayName.keyword': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [
        {
          key: 'di',
          doc_count: 6,
        },
      ],
    },
  },
};
